import { ApiService } from "../api.service";


export class QuestionnaireService {

	constructor(private apiService: ApiService) {}

  //查询用户相应能力满意度
  getUserQuestionnaireInfo(learningPathMetaId){
	  return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v1/usersSatisficing/learningPathMetaId/' + learningPathMetaId
    })
  }

  //保存用户满意度信息
  saveUserQuestionnaireInfo(data){
	  return this.apiService.ajax({
      'type': 'POST',
      'url': 'ddilearner/v1/usersSatisficing',
      'data': data
    }).toPromise();
  }

  //查询满意度页面显示信息
  getQuestionnaireContent(){
	  return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v1/usersSatisficingMetas'
    })
  }



}



// WEBPACK FOOTER //
// ./src/app/app-questionnaire/questionnaireService.ts